import React from 'react';
import { ClipboardList } from 'lucide-react';

interface DiagnosisWidgetProps {
  primary: string;
  definitive: string;
}

export function DiagnosisWidget({ primary, definitive }: DiagnosisWidgetProps) {
  return (
    <div className="bg-white dark:bg-neutral-900 p-6 rounded-2xl border border-gray-100 dark:border-neutral-800 shadow-sm h-full">
      <div className="flex items-center gap-2 text-teal-600 mb-6">
        <ClipboardList className="w-5 h-5" />
        <h4 className="font-bold">Diagnóstico</h4>
      </div>

      <div className="space-y-6">
        <div>
          <p className="text-[10px] uppercase font-bold text-gray-400 mb-1">Hipótese Diagnóstica</p>
          <p className="text-sm font-bold text-gray-900 dark:text-white leading-snug">{primary}</p>
        </div>

        <div className="pt-6 border-t border-gray-100 dark:border-neutral-800">
          <p className="text-[10px] uppercase font-bold text-gray-400 mb-1">Diagnóstico Definitivo</p>
          <p className="text-sm font-medium text-gray-500 italic leading-relaxed">{definitive}</p>
        </div>
      </div>
    </div>
  );
}
